import React from 'react';
import { ProductCollection, DescriptionSlice } from '../../../../types';
import * as S from './styles';

type Props = {
  productCollection: ProductCollection;
} & Pick<DescriptionSlice, 'description'>;

const Description = ({ productCollection, description }: Props) => {
  if (!description) {
    return null;
  }
  return (
    <S.DescriptionContainer>
      <S.DescriptionTitle>{productCollection.name}</S.DescriptionTitle>
      <S.Description data-test="ProductCollectionDescription">
        {description}
      </S.Description>
    </S.DescriptionContainer>
  );
};

export default Description;
